import { flatten } from 'lodash'
import repository from '@/repositories/Repository'

const resource = '/items'
// コード検索を行う際一回で送信するコード数
// GETで商品コードを送るため、長すぎになることを防ぐため最大値を用意
const ITEMS_SEND_CHUNK_SIZE = 100

/**
 * 商品マスタ
 */
export default {
  /**
   * 指定キーワードで商品検索を行う
   *
   * @param {String} company 企業コード
   * @param {Array<String>} categories 最下層の分類コード
   * @param {String} keyword 検索ワード
   * @param {Object} postData フィルタデータ
   */
  getByKeyword(company, categories, keyword, postData) {
    return repository.bizoo
      .post(
        `${resource}/${company}?itemCategories=${categories.join(
          ',',
        )}&keyword=${keyword}`,
        postData,
      )
      .then(r => r.data)
  },
  /**
   * 商品コードから商品検索を行う
   *
   * @param {String} company 企業コード
   * @param {Array<String>} codes 商品コード
   * @param {Object} postData フィルタデータ
   */
  getByCode(company, codes, postData) {
    const codesCopy = Array.from(codes)
    const chunks = []
    while (codesCopy.length > 0) {
      chunks.push(codesCopy.splice(0, ITEMS_SEND_CHUNK_SIZE))
    }

    return Promise.all(
      chunks.map(chunk => {
        return repository.bizoo
          .post(`${resource}/${company}?codes=${chunk.join(',')}`, postData)
          .then(r => r.data)
      }),
    ).then(results => flatten(results))
  },
}
